import { CmsPicture } from '@domgen/dgx-fe-cms';
import { NavigationLink, Theme } from '@domgen/dgx-fe-common';

export interface CmsArticleSearchForm {
  picture?: CmsPicture;
  quickLinks: NavigationLink[];
  theme: Theme;
  articleSearchIntro: string;
  articleSearchBody: string;
  articleSearchTitle: string;
}
